<title>{{ iagPortalsReportsPage.htmlTitle }}</title>
<div class="container">
  <app-section [sections]="iagPortalsReportsPage.sectionsJustAboveImageReports" [isIAGPortalDocumentationPage]="true"> </app-section>
  <app-iag-portal-accordian-section [accordianSections]="iagPortalsReportsPage.sectionReportViewSectionAccordion"></app-iag-portal-accordian-section>
  <app-section [sections]="iagPortalsReportsPage.sectionsJustBellowImageReports" [isIAGPortalDocumentationPage]="true"> </app-section>
</div>
